import React from "react";
import DateRange from "./DateRange";
import CustomerFilter from "./CustomerFilter";
import Checkbox from "../../../common/Checkbox/Checkbox";
import { Button } from "../../../common/Button/Button";

export default function ContainerActions(props) {
	return (
		<>
			<div className="row" style={{marginTop:"5px"}}>
				<div className="col-md-12 inline-margin-facilitatorview">
					<label>
						<b>Search and Filter</b>
					</label>
					<div style={{clear:"both"}}></div>
					<CustomerFilter
						options={props.customerFilterOptions}
						onCustomerFilterChange={props.onCustomerFilterChange}
						customerFilter={props.customerFilter}
						onCustomerFilterValueChange={
							props.onCustomerFilterValueChange
						}
						onSearchClicked={props.onSearchClicked}
						customerFilterValue={props.customerFilterValue}
					></CustomerFilter>

					<DateRange
						options={props.dateRangeOption}
						onDateRangeChange={props.onDateRangeChange}
						onDateFilterChange={props.onDateFilterChange}
						dateFilter={props.dateFilter}
						fromDate={props.fromDate}
						toDate={props.toDate}
						isForFacilitator={true}
					></DateRange>

					<Button className="inline-button" onClick={props.onSearchClicked}>Reload</Button>

					

				</div>
			</div>
			<div className="row">
				<div className="col-md-2">
					<Checkbox
						id={`checkbox-handled`}
						checked={props.showIncompleteActions}
						onChange={props.toggleShowIncompleteActions}
						label={"Incomplete only"}
					></Checkbox>
				</div>
				<a
						href="/home/facilitator-service-progression/"
						target="_blank"
						style={{marginTop:"3px"}}
					>
						{" "}
						Manage Services
					</a>
			</div>
		</>
	);
}
